import { Injectable } from '@angular/core';
import { Observable,throwError } from 'rxjs';
import {environment} from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import * as CryptoJS from "crypto-js";
@Injectable({
  providedIn: 'root'
})
export class CustomServiceService {

  constructor(private router: Router, private http: HttpClient) { }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Get client-side error\n${error.error.message}`;
    } else {
      errorMessage = `Get server-side error\nError Code: ${error.status}\nMessage: ${error.message}`;
    }
   console.error(errorMessage);
    return throwError(errorMessage);
  }

  
  getTenderlist(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageTender/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getManageDepotDetails(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageDepotDetails/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getdepotlistData(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/get-depot-list';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
 
 
  
  getTenderDetails(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageTender/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getTenderDetailsList(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageTender/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getDepotList(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageDepotDetails/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  
  getDirectoryList(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/DirectoryOfOfficers/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  
  getZoneList():Observable<any>{ 
    let requestParam = btoa(JSON.stringify({}));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/get-zone-list';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events' 
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  GetAllZoneById(data:any):Observable<any>{ 
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/get-zone-byid';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events' 
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

 
  GetRegionByZoneId(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/get-region-by-zoneid';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  
 
  GetDepotByRegionCode(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/get-depo-by-regioncode';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  
  GetDepotByRegionId(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/get-deopt-by-regionid';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  GetCurrnetRecruitment(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageRecruitment/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  GetPreviousRecruitment(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageRecruitment/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }






  getBoardDirectoryList(data:any):Observable<any>{ 
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/BoardofDirectors/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  

  getCircular(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageNewsPage/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

 

  getAnnualReportList(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/AnnualReport/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getHandBookList(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageDownloads/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getCommonPagelist(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageCommonPage/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  
  getContactDirectoryList(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ContactDirectory/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getManageOfficeOrderList(data:any){
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageOfficeOrder/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  



  GlobalSearchList(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/global-search';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  ContentsearchMenulist(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ContentsearchMenulist';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getManuDetails(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageMenu/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  VisitorCounter(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/visitor-counter';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }



  mysql_real_escape_string(str:any):any {
    if(str==""){
      return "";
    }
      return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char:any):any {
          switch (char) {
              case "\0":
                  return "\\0";
              case "\x08":
                  return "\\b";
              case "\x09":
                  return "\\t";
              case "\x1a":
                  return "\\z";
              case "\n":
                  return "\\n";
              case "\r":
                  return "\\r";
              case "\"":
              case "'":
              case "\\":
              case "%":
              return "\\"+char; 
          }
      });
  }


  EmpeeloyCorner(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/EmployeeCorner/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  EmpeeloyCornerDoclist(params:any,page:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+`api/employee-cornor-doc-list?page=${page}`;
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe( 
      catchError(this.errorMgmt)
    );
  }



  checkcookies(key:any):boolean{
    var data,keyis;
    keyis = false;
    if(document.cookie.length==0) {  
      keyis= false;
    } else { 
      let all = document.cookie.split("; ");
      all.forEach((item,index)=>{
        data = item.split("=");
        if(data[0]==key){
          keyis= true;
        }
      })
    }
    return keyis;
  }

  getcookies(key:any):any{
      var data
      data = null;
      if(document.cookie.length==0) {  
        data=null;
      } else {
        let all = document.cookie.split("; "); 
        all.forEach((item,index)=>{
          if(item.split("=")[0]==key){
            data=item.split("=")[1];
          } else{
            data=null;
          }
        })
      }
     return data;
  }

  removecookies(key:any):boolean {
    if(this.checkcookies(key)){
      document.cookie = key+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      return true;
    } else {
      return false;
    }
  } 
  



  PluginPageDetials(params:any):Observable<any>{ 
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/plugin-navbar-details';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events' 
    }).pipe( 
      catchError(this.errorMgmt)
    );
  } 
 
  getContentPageDetials(params:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/content-navbar-details';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }



  getDivisionList(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageDivision/viewall';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  getDesignation(data:any,url:any){
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+url;
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getBlogsList(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageBlog/viewall';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getZoneAbout(data:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(data));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+'api/ManageZoneAbout/viewall';
    return this.http.post(apiUrl, reqData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  currentDateTime() {
    const now = new Date();
    let month:any = now.getMonth() + 1;
    let dateis:any = now.getDate();
    let h:any = now.getHours();
    let m:any = now.getMinutes();
    let s:any = now.getSeconds();
    if (dateis <= 9) {
      dateis = `0${dateis}`;
  } else {
    dateis = dateis;
  }
    if (month <= 9) {
        month = `0${month}`;
    } else {
        month = month;
    }
    if (h <= 9) {
      h = `0${h}`;
    } else {
      h = h;
    }
    if (m <= 9) {
      m = `0${m}`;
    } else {
      m = m;
    }
    if (s <= 9) {
      s = `0${s}`;
    } else {
      s = s;
    }
    let date:any = `${now.getFullYear()}-${month}-${dateis}`;
    let reverse_date:any = `${dateis}-${month}-${now.getFullYear()}`;
    let time:any = `${h}:${m}:${s}`;//:${now.getMilliseconds()}
    let HM:any = `${h}:${m}`;
    let hour = (time.split(':'))[0]
    let min = (time.split(':'))[1]
    let part = hour > 11 ? 'PM' : 'AM';
    if(parseInt(hour) == 0)
    hour = 12;
    min = (min+'').length == 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour+'').length == 1 ? `0${hour}` : hour;
  return {
    reverse_date:reverse_date,
    date:date,
    time:time,
    HM:HM,
    time_convert:`${hour}:${min} ${part}`,
    part:part,
    datetimeinnum:`${now.getFullYear()}${month}${dateis}${h}${m}${s}`
  };
}




GetOverViewList(data:any):Observable<any>{ 
  let requestParam = btoa(JSON.stringify(data));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+'api/ManageOverview/viewall';
  return this.http.post(apiUrl, formParams, {
    reportProgress: true,
    observe: 'events'
  }).pipe(
    catchError(this.errorMgmt)
  );
}


getCircularListNew(params:any,apiurl:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(params));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+apiurl;
  return this.http.post(apiUrl, formParams, {
    reportProgress: true,
    observe: 'events'
  }).pipe(
    catchError(this.errorMgmt)
  );
}
getProcrumentListing(params:any,apiurl:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(params));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+apiurl;
  return this.http.post(apiUrl, formParams, {
    reportProgress: true,
    observe: 'events'
  }).pipe(
    catchError(this.errorMgmt)
  );
}

getqualitycontrolData(params:any,route:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(params));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+route;
  return this.http.post(apiUrl, formParams).pipe(
    catchError(this.errorMgmt)
  );
}

getFarmerBenefit(params:any,route:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(params));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+route;
  return this.http.post(apiUrl, formParams).pipe(
    catchError(this.errorMgmt)
  );
}


CommonContactData(params:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(params));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+'api/CommonContactData/viewall';
  return this.http.post(apiUrl, formParams, {
    reportProgress: true,
    observe: 'events'
  }).pipe(
    catchError(this.errorMgmt)
  );
}


////// Organisation Structure API Start //////////
getZoneListNew():Observable<any>{ 
  let requestParam = btoa(JSON.stringify({}));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+'api/get-zone-list-new';
  return this.http.post(apiUrl, reqData, {
    reportProgress: true,
    observe: 'events' 
  }).pipe(
    catchError(this.errorMgmt)
  );
}

GetRegionByZoneName(data:any):Observable<any>{ 
  let requestParam = btoa(JSON.stringify(data));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+'api/get-region-by-zone-name';
  return this.http.post(apiUrl, reqData, {
    reportProgress: true,
    observe: 'events'
  }).pipe(
    catchError(this.errorMgmt)
  );
}


GetDistrictAndDepotByRegionName(data:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(data));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+'api/GetDistrictAndDepotByRegionName';
  return this.http.post(apiUrl, reqData, {
    reportProgress: true,
    observe: 'events'
  }).pipe(
    catchError(this.errorMgmt)
  );
}
////// Organisation Structure API End //////////


/////////////////grievance works //////////////////


checkuserIsloggedin(): boolean {
  let user:any = window.localStorage.getItem('grievanceuser');
  if (user=="" || user==undefined || user==null) {
    return false;
  } else {
    return true;
  }
}

loggedinUser(): any {
  let user:any = window.localStorage.getItem('grievanceuser');
  if (user=="" || user==undefined || user==null) {
    return false;
  } else {
    return JSON.parse(CryptoJS.AES.decrypt(user,environment.apiHashingKey).toString(CryptoJS.enc.Utf8));
  }
}
/////////////////grievance works //////////////////

CommonPostFn(params:any,route:any):Observable<any>{
  let requestParam = btoa(JSON.stringify(params));
  let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
  let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
  let apiUrl = environment.apiUrl+route;
  return this.http.post(apiUrl, formParams).pipe(
    catchError(this.errorMgmt)
  );
}



}
